require("./projectNameFilter.js");
require("./projectValueFilter.js");
require("./projectTerrainFilter.js");
require("./contractTypeFilter.js");
require("./contractorNameFilter.js");
require("./contractorsFilter.js");
require("./contractorsHierachyFilter.js");
require("./industrySectorsFilter.js");
require("./projectTypesFilter.js");
require("./projectStagesFilter.js");
require("./projectStatusesFilter.js");
require("./projectLocationFilter.js");
require("./contractAwardDateFilter.js");
require("./contractStageFilter.js");
require("./operatorsFilter.js");
require("./startupYearFilter.js");
require("./equipmentTypeFilter.js");
require("./pipelinesFilter.js");
require("./powerOutputFilter.js");
require("./projectCreatedDateFilter.js");
require("./fullTextFilter.js")
require("./waterDepthFilter.js");
require("./windTurbineManufacturersFilter.js");
require("./fidDateFilter.js");
require("./offshoreWindFoundationTypeFilter.js");

module.exports = "filters";
